import ErrorBoundary from '@/components/ErrorBoundary';
import { DefaultComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { Tiktok, TiktokProps } from './Tiktok';

export interface StandaloneTiktokProps extends StandaloneComponentProps {
  markup?: TiktokProps['markup'];
  options?: Omit<TiktokProps, 'markup'>;
}

export const StandaloneTiktok: StandaloneComponent<StandaloneTiktokProps> = ({ markup, options, ...props }) => {
  return (
    <ErrorBoundary>
      <Tiktok {...{ markup }} {...options} {...props} />
    </ErrorBoundary>
  );
};

const DefaultTiktok: DefaultComponent = ({ type, data, meta, descendants }) => {
  return (
    <StandaloneTiktok
      markup={data.oembed.html}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export const standalone = StandaloneTiktok;

export default DefaultTiktok;
